import { AppTheme } from 'types/themeTypes';
import { StyleRules } from '@material-ui/core/styles';

export default (theme: AppTheme): StyleRules => {
  return {
    '@keyframes loadingSpin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    circle: { stroke: '#2E83D9' },
    loadingIndicator: {
      '& circle': {
        stroke: '#2E83D9',
      },
      animation: '$loadingSpin infinite 1s linear',
    },
  };
};
